export class ProductListingModel {
    PageNumber: number = 1;
    PageSize: number = 10;
    KeyWord: string = "";
    CategoryNames: string;
    CategoryIds: string;
    CategoryId: string;
    ProductId: string = "";
}

export class ProductList {
    id: number;
    productName: string;
    productTitle: string;
    categoryNames: string;
    categoryIds: string;
    companyAddressId: string;
    price: number;
    priceFormatted: string;
    discount: number;
    isShowDiscount: boolean;
    isShowDiscountValue: string;
    isJustAddedValue: string;
    isSaleValue: string;
    isQuoteValue: string;
    isSale: string;
    isQuote: string;
    features: string;
    description: string;
    dateFormatted: string;
    searchTags:string;
    isActive: boolean;
    title: string;
    length: string;
    width: string;
    height: string;
    weight: string;
    isActiveValue: string;
    isShippingRequired: boolean;
    isShippingRequiredValue: string;
    isSelected: boolean;
    imageLoader: boolean = true;
    productImage: string;
    productId: any;
    productType: number;
    isAccessoriesValue: string;
}

export class ProductResponseModel {
    ProductList: Array<ProductList> = [];
    TotalPages: number;
}

export class RelatedProductList {
    id: number;
    productName: string;
    productTitle: string;
    categoryNames: string;
    categoryIds: string;
    companyAddressId: string;
    price: number;
    priceFormatted: string;
    discount: number;
    isShowDiscount: boolean;
    isShowDiscountValue: string;
    isJustAddedValue: string;
    isSaleValue: string;
    isQuoteValue: string;
    isSale: string;
    isQuote: string;
    features: string;
    description: string;
    dateFormatted: string;
    searchTags:string;
    isActive: boolean;
    title: string;
    length: string;
    width: string;
    height: string;
    weight: string;
    isActiveValue: string;
    isShippingRequired: boolean;
    isShippingRequiredValue: string;
    isSelected: boolean;
    imageLoader: boolean = true;
    fileTitle: string;
    productImage: string;
    productId: string;
}

export class RelatedProductListModel {
    RelatedProductList: Array<RelatedProductList> = [];
    TotalPages: number;
}